import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  flow_id: [
    {...makeRule('请输入正确的图片流转ID', 'integer', 'blur', false), min: 1},
  ],
  order_id: [
    {...makeRule('请输入正确的工单ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入图片流转工单名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
}



// WEBPACK FOOTER //
// ./src/views/img-flow-order/img-flow-order.rules.js